import template from './dealer-popup.vhtml';
import { i18n } from '../../translation.js';

export default {
	template,
	props: {
		qdPopup: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			popupData: null,
		};
	},
	methods: {
		isOdd( num ) {
			return num % 2;
		},
	},
	watch: {
		qdPopup() {
			this.popupData = this.qdPopup !== null ? this.qdPopup.data : null;
		},
	},

};


// WEBPACK FOOTER //
// ./assets/_js/components/dealer-popup/dealer-popup.js